import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Palette, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminEComicsSales() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/ecomics/admin/purchases").then(r => setData(r.data)).catch(() => setData({ purchases: [], count: 0, amount_total_inr: 0 }));
  }, []);

  if (!data) return null;

  return (
    <div className="bb-card p-6 md:col-span-3" data-testid="ecomics-sales-report">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="bb-overline text-[var(--bb-muted)] flex items-center gap-2"><Palette size={14}/> E-COMICS SALES</div>
        <div className="flex items-center gap-4">
          <div className="text-sm text-[var(--bb-forest)]" data-testid="ecomics-sales-total">
            {data.count} purchase{data.count === 1 ? "" : "s"} · <span className="font-serif text-lg">₹{data.amount_total_inr.toLocaleString()}</span>
          </div>
          <a href={`${API}/ecomics/admin/purchases.csv`} className="bb-btn-secondary !py-1.5 !px-3 text-xs inline-flex items-center gap-1.5" data-testid="ecomics-sales-csv-btn">
            <Download size={12}/> Download CSV
          </a>
        </div>
      </div>
      {data.purchases.length === 0 ? (
        <div className="p-8 text-center text-sm text-[var(--bb-muted)]" data-testid="ecomics-sales-empty">No E-Comics purchases yet.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-[var(--bb-sand)] bb-overline text-[var(--bb-muted)]">
              <tr>
                <th className="p-3 text-left">Buyer</th>
                <th className="p-3 text-left">Volume</th>
                <th className="p-3 text-right">Amount</th>
                <th className="p-3 text-left">Payment ID</th>
                <th className="p-3 text-left">Date</th>
              </tr>
            </thead>
            <tbody>
              {data.purchases.map(p => (
                <tr key={p.purchase_id} className="border-t border-[var(--bb-border)]" data-testid={`ecomics-sale-${p.purchase_id}`}>
                  <td className="p-3">
                    <div className="font-medium">{p.buyer_name || "—"}</div>
                    <div className="text-xs text-[var(--bb-muted)]">{p.buyer_email}</div>
                  </td>
                  <td className="p-3">Vol {p.volume_number} · {p.volume_title}</td>
                  <td className="p-3 text-right">₹{p.amount_inr}</td>
                  <td className="p-3 text-xs text-[var(--bb-muted)]">{p.payment_id}</td>
                  <td className="p-3 text-xs">{p.paid_at ? new Date(p.paid_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
